import styled from '@emotion/styled';
import { MessageExtendComplex } from '../MessageExtend/MessageExtendComplex';
import { BaseMsgProps } from './types';

function FaqFeedback(props: BaseMsgProps) {
  const { faqFeedbackContent } = props.raw;

  if (!faqFeedbackContent) {
    return <></>;
  }

  return (
    <MessageExtendComplex
      {...props}
      content={<Container>{faqFeedbackContent.helpful ? 'YES' : 'NO'}</Container>}
    />
  );
}

const Container = styled.div`
  max-width: 450px;
  padding: 8px 12px;
  border-radius: 4px;
  background: #fff;
`;

export default FaqFeedback;
